import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getSurvey } from '../../../bridge';
import { getCopyrightMessage } from '../../../helpers/itpmetricsUtils';
import { useAuthContext } from '../../../hooks/useAuthContext';
import ContentSection from '../common/ContentSection';
import Loading from '../common/Loading';
import Page from '../common/Page';
import SignedOut from '../common/SignedOutDialog';

import ReportError from './ReportError';
import SurveyReportBody from './SurveyReportBody';

function SurveyReport() {
  const { user } = useAuthContext();
  const [result, setResult] = useState(null);
  const { surveyId } = useParams();
  const [loading, setLoading] = useState(true);
  const [reportError, setReportError] = useState(null);

  useEffect(() => {
    if (!surveyId) {
      return;
    }
    const fetchReport = async () => {
      await setLoading(true);
      const r = await getSurvey(surveyId);
      await setLoading(false);
      if (r.error) {
        await setReportError(r.error);
        return;
      }
      await setResult(r.response);
    };
    fetchReport();
  }, [surveyId]);

  if (!user) {
    return <SignedOut />;
  }

  if (loading) {
    return <Loading />;
  }

  if (reportError) {
    return <ReportError error={reportError} />;
  }

  if (!result) {
    return null;
  }

  return (
    <Page footer={false}>
      <ContentSection>
        {result && (
          <SurveyReportBody
            respondents={result.respondents}
            survey={result.survey}
            template={result.template}
          />
        )}
        <footer className="justify-content-center">
          {getCopyrightMessage()}
        </footer>
      </ContentSection>
    </Page>
  );
}

export default SurveyReport;
